import React, {useEffect, useState} from "react";

const classNames = require('classnames');


interface InputProps {
    label?: string,
    placeholder: string,
    onChange?: (data: any) => void,
    clear?: boolean,
    type?: string,
    extraClass?: Array<string>,
    value?:any,
    isTextArea?: boolean,
    icon?:string,
    children?: React.ReactNode,
    [propName:string]:any,
    maxLen?:number
}

function Input({label, placeholder , onChange,maxLen, clear = false, type = 'text', extraClass = [], children, isTextArea = false,value = '',...rest}: InputProps) {

    const [values, setValue] = useState<string>(value);
    const [showClear, setClear] = useState(false);
    const [password, setPassword] = useState(false);
    const errors = rest['data-__field'].errors;

    useEffect(() => {
        setValue(value)
    },[value])

    const inputHandler = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        var value = maxLen ? e.target.value.substr(0,maxLen) : e.target.value
        setValue(value);
        if(onChange){
            onChange(value);
        }
        setClear(value.length !== 0)
    }

    const cleanHandler = () => {
        setValue('');
       if(onChange){
           onChange('');
       }
        setClear(false)
    }

    return <div className={classNames(["common-input-box"].concat(extraClass),{'textarea':isTextArea,'clear':clear})}>
        <div className="common-input-item">
            <div className="_left">
                {
                    label &&  <p className="name"> {
                        rest.icon && <span className='iconfont' dangerouslySetInnerHTML={{ __html:rest.icon }}/>
                    } {label}</p>
                }

                {
                    isTextArea ?
                        <textarea onChange={inputHandler} autoComplete='off' placeholder={placeholder} value={values}/> :
                        <input type={password ? 'text' : type} onChange={inputHandler} autoComplete='off'
                               placeholder={placeholder} value={values} maxLength={50}/>
                }

            </div>
            {
                clear && <div className={classNames("_clean","input-icon", {'no-empty': showClear})} onClick={cleanHandler}>
                    <p className="iconfont">&#xe611;</p>
                </div>
            }
            {
                type === 'password' && <div className='pass-icon input-icon' onClick={() => setPassword(!password)}>
                    {
                        password ? <p className="iconfont">&#xe60a;</p> : <p className="iconfont">&#xe60b;</p>
                    }

                </div>
            }
            {
                children && <div className="children">{children}</div>
            }

        </div>
        {
            errors && <p className='error'>{ errors[0].message }</p>
        }

        {
            maxLen && <p className="maxLen">{ values.length } / { maxLen }</p>
        }
    </div>
}

export default Input;
